/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseShapeIcon24Solid = forwardRef('MediaUiAPauseShapeIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.25 4C5.56 4 5 4.56 5 5.25v13.5c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V5.25C10 4.56 9.44 4 8.75 4h-2.5Z" }),
        React.createElement("path", { d: "M15.25 4C14.56 4 14 4.56 14 5.25v13.5c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V5.25C19 4.56 18.44 4 17.75 4h-2.5Z" })));
});
